import React from 'react'
import './Biofuel.css';

function Gwp() {
    return (
        <div className='text-start'>
        <div className='d-flex justify-content-center mt-3'>
            <div class="card">
                <div class="card-body">
               <table>
                <tr>
                    <th>Biofuel Production Pathway</th>
                    <th>GHG Emissions Saving – Default Value</th>
                </tr>
                <tr class="highlight-red"><td>Sugar beet ethanol (no biogas from slop, natural gas as process fuel in conventional boiler)</td><td>59%</td></tr>
                <tr class="highlight-green"><td>Sugar beet ethanol (with biogas from slop, natural gas as process fuel in conventional boiler)</td><td>73%</td></tr>
                <tr class="highlight-green"><td>Sugar beet ethanol (no biogas from slop, natural gas as process fuel in CHP plant *)</td><td>68%</td></tr>
                <tr class="highlight-green"><td>Sugar beet ethanol (with biogas from slop, natural gas as process fuel in CHP plant *)</td><td>76%</td></tr>
                <tr class="highlight-red"><td>Sugar beet ethanol (no biogas from slop, lignite as process fuel in CHP plant *)</td><td>47%</td></tr>
                <tr class="highlight-red"><td>Sugar beet ethanol (with biogas from slop, lignite as process fuel in CHP plant *)</td><td>64%</td></tr>
                <tr class="highlight-red"><td>Corn (maize) ethanol (natural gas as process fuel in conventional boiler)</td><td>40%</td></tr>
                <tr class="highlight-red"><td>Corn (maize) ethanol, (natural gas as process fuel in CHP plant *)</td><td>48%</td></tr>
                <tr class="highlight-red"><td>Corn (maize) ethanol (lignite as process fuel in CHP plant *)</td><td>28%</td></tr>
                <tr class="highlight-green"><td>Corn (maize) ethanol (forest residues as process fuel in CHP plant *)</td><td>68%</td></tr>
                <tr class="highlight-red"><td>Other cereals excluding maize ethanol (natural gas as process fuel in conventional boiler)</td><td>38%</td></tr>
                <tr class="highlight-red"><td>Other cereals excluding maize ethanol (natural gas as process fuel in CHP plant *)</td><td>46%</td></tr>
                <tr class="highlight-red"><td>Other cereals excluding maize ethanol (lignite as process fuel in CHP plant *)</td><td>24%</td></tr>
                <tr class="highlight-green"><td>Other cereals excluding maize ethanol (forest residues as process fuel in CHP plant *)</td><td>67%</td></tr>
                <tr class="highlight-green"><td>Sugar cane ethanol</td><td>70%</td></tr>
                <tr><td>The part from renewable sources of ethyl-tertio-butyl-ether (ETBE)</td><td>Equal to that of the ethanol production pathway used</td></tr>
                <tr><td>The part from renewable sources of tertiary-amyl-ethyl-ether (TAEE)</td><td>Equal to that of the ethanol production pathway used</td></tr>
                <tr class="highlight-red"><td>Rape seed biodiesel</td><td>47%</td></tr>
                <tr class="highlight-red"><td>Sunflower biodiesel</td><td>52%</td></tr>
                <tr class="highlight-red"><td>Soybean biodiesel</td><td>50%</td></tr>
                <tr class="highlight-red"><td>Palm oil biodiesel (open effluent pond)</td><td>19%</td></tr>
                <tr class="highlight-red"><td>Palm oil biodiesel (process with methane capture at oil mill)</td><td>45%</td></tr>
                <tr class="highlight-green"><td>Waste cooking oil biodiesel</td><td>84%</td></tr>
                <tr class="highlight-green"><td>Animal fats from rendering biodiesel **</td><td>78%</td></tr>
                <tr class="highlight-red"><td>Hydrotreated vegetable oil from rape seed</td><td>47%</td></tr>
                <tr class="highlight-red"><td>Hydrotreated vegetable oil from sunflower</td><td>54%</td></tr>
                <tr class="highlight-red"><td>Hydrotreated vegetable oil from soybean</td><td>51%</td></tr>
                <tr class="highlight-red"><td>Hydrotreated vegetable oil from palm oil (open effluent pond)</td><td>22%</td></tr>
                <tr class="highlight-red"><td>Hydrotreated vegetable oil from palm oil (process with methane capture at oil mill)</td><td>49%</td></tr>
                <tr class="highlight-green"><td>Hydrotreated oil from waste cooking oil</td><td>83%</td></tr>
                <tr class="highlight-green"><td>Hydrotreated oil from animal fats from rendering **</td><td>77%</td></tr>
                <tr class="highlight-red"><td>Pure vegetable oil from rape seed</td><td>57%</td></tr>
                <tr class="highlight-red"><td>Pure vegetable oil from sunflower</td><td>64%</td></tr>
                <tr class="highlight-red"><td>Pure vegetable oil from soybean</td><td>61%</td></tr>
                <tr class="highlight-red"><td>Pure vegetable oil from palm oil (open effluent pond)</td><td>30%</td></tr>
                <tr class="highlight-red"><td>Pure vegetable oil from palm oil (process with methane capture at oil mill)</td><td>57%</td></tr>
                <tr class="highlight-green"><td>Pure oil from waste cooking oil</td><td>98%</td></tr>
               </table>

                <p class="note">(*) Default values for processes using CHP are valid only if all the process heat is supplied by CHP.</p>
                <p class="note">(**) Applies only to biofuels produced from animal by-products classified as category 1 and 2 material according to Regulation (EC) No 1069/2009.</p>

                </div>
            </div>




            
</div>

        </div>
    )
}

export default Gwp